module.exports = __webpack_public_path__ + "img/help_download_small.01ee7b1a.png";